import {UUID} from '../../../shared/types/uuid.type';
import { createAction, props } from '@ngrx/store';

const prefix = '[DeleteManyDVRs] ';

export const deleteManyDvr = createAction(
  `${prefix} Delete Many DVRs`,
  props<{ ids: UUID[] }>()
);

export const deleteManyDvrSuccess = createAction(
  `${prefix} Delete Many DVRs Success`,
  props<{ ids: UUID[] }>()
);

export const deleteManyDvrFailure = createAction(
  `${prefix} Delete Many DVRs Failure`,
  props<{ error: any }>()
);

export const clearDeleteManyDvrState = createAction(
  `${prefix} Clear Delete Many DVRs State`,
);
